module.exports = __webpack_public_path__ + "img/star.88659160.png";